import * as types from "./mutations-types";

export default {
    [types.SET_FUTURE_RELESES_PERIOD](state, future_release_period) {
        state.future_releases_period = future_release_period;
    }
};